module.exports = "<shop-items class=\"col-md-7\"></shop-items>\n<checkout class=\"col-md-offset-1 col-md-4\"></checkout>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/admin-shop/admin-shop.component.html
// module id = ./src/app/admin/admin-shop/admin-shop.component.html
// module chunks = main